import ExternalLink from './ExternalLink'

export default ExternalLink
